import React from 'react';
import _ from 'lodash';

import WithUser from 'shared/HOCs/WithUser';

class VisibleIfUserIsNotLogged extends React.Component {
  render() {
    return _.isNil(this.props.user)
      ? _.get(this.props, 'children', null)
      : null;
  }
}

export default WithUser(VisibleIfUserIsNotLogged);
